module.exports = "<h1>Sales Dashboard</h1>\r\n"